export default {
  routes: [
    {
      name: 'posts_templates',
      path: '/directory/post_templates',
      component: () => import('./views/ThePostPages.vue'),

    },

    {
      name: 'post_templates',
      path: '/directory/post_templates/:uuid',
      component: () => import('./views/ThePostPage.vue'),
    },
  ]
}
